import classNames from 'classnames';
import classes from './NoDataFallback.module.scss';
function NoDataFallback({ className, icon, text, ...props }) {
    return (
        <div className={classNames(classes.noDataFallback, className)} {...props}>
            <div className={classes.imageWrapper}>{icon}</div>
            <h4 className={classes.text}>{text}</h4>
        </div>
    );
}
export default NoDataFallback;
